module.exports = __webpack_public_path__ + "img/logo-2.212a0c02.png";